import gql from 'graphql-tag';

export const COMPLETE_DEAL_EVENT_ACTIVITIES = gql`
  mutation CompleteDealEventActivities($input: CompleteDealEventActivitiesInput!) {
    dealActivity {
      result: completeDealEventActivities(input: $input) {
        error
        success
        list {
          id
        }
      }
    }
  }
`;
